import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ProvideDefaultPathsContext } from '@/router/context';
import { useAppSelector } from '@/store';

type AuthenticatedGuardProps = {
  children: React.ReactNode;
  unauthenticatedRedirectPath?: string;
};

export function AuthenticatedGuard(props: AuthenticatedGuardProps) {
  const location = useLocation();
  const appState = useAppSelector(state => state.appState);
  const defaultPaths = useContext(ProvideDefaultPathsContext);

  if (!appState.authenticated) {
    console.log('User not authenticated, redirecting to login.');
    return (
      <Navigate
        to={props.unauthenticatedRedirectPath || defaultPaths?.loginPath}
        state={{ from: location }}
        replace />
    );
  }

  return props.children;
}

type UnauthenticatedGuardProps = {
  children: React.ReactNode;
};

export function UnauthenticatedGuard(props: UnauthenticatedGuardProps) {
  const location = useLocation();
  const appState = useAppSelector(state => state.appState);
  const defaultPaths = useContext(ProvideDefaultPathsContext);

  if (appState.authenticated) {
    return (
      <Navigate
        to={defaultPaths.homePath}
        state={{ from: location }}
        replace />
    );
  }

  return props.children;
}